import React, {Component} from 'react';
import classnames from 'classnames';

import styles from './Header.scss';
import AuthHeaderContainer from '../Auth/AuthHeaderContainer';
import Logo from './Logo';
import GuestNavigationBar from './GuestNavigationBar';
import {IndexLink} from 'react-router';
import AdminNavigationBar from './AdminNavigationBar';
import DoctorNavigationBar from './DoctorNavigationBarContainer';
import PatientNavigationBar from './PatientNavigationBar';

import {getNextPathOnRole} from '../helpers/Role';
import VmaNavigationBar from './VmaNavigationBar';
import AuthHeader from "../Auth/AuthHeader";

export default function Header(props) {
    const logoLink = "https://app.cirrusmed.com";

    return (
        <header className={classnames(styles.header, {
            [styles.homePageOpened]: true,
        })}>
            <IndexLink to={logoLink} className={styles.logoLink}>
                <Logo homePageOpened />
            </IndexLink>
            <GuestNavigationBar homePageOpened {...props} />
            <AuthHeader
                onShowLogin={() => window.location = "https://app.cirrusmed.com/?signIn=1"}
                onShowRegistration={() => window.location = "https://app.cirrusmed.com/?signUp=1"}
                {...props} />
        </header>
    );
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.js